import { z } from "zod";

/** wx.requestPayment 所需参数，全部由服务端签发。 */
export const wechatPaymentParamsSchema = z.object({
  timeStamp: z.string().regex(/^\d+$/),
  nonceStr: z.string().min(1),
  package: z.string().startsWith("prepay_id="),
  signType: z.literal("RSA"),
  paySign: z.string().min(1),
});
export type WechatPaymentParamsPayload = z.infer<typeof wechatPaymentParamsSchema>;
